<div class="delete-modal modal-el" (click)="backdropClick($event)" data-test-id="delete-user-modal">
  <div class="delete-info modal-info-box">
    <div class="delete-title">Delete User</div>
    <div class="delete-user-name">{{ user.firstName }} {{ user.lastName }}</div>
    <div
      *ngIf="currentUser && currentUser.id === user.id"
      class="self-delete-info"
    >
      You are trying to delete yourself
    </div>
    <img src="/assets/img/delete_user.svg" alt="delete user" />
    <div class="delete-hint">
      This will delete user from the list. Are you sure?
    </div>
    <div class="delete-actions form-actions">
      <button
        mat-stroked-button
        class="cancel-btn"
        (click)="closeModal()"
        data-test-id="delete-user-cancel"
      >
        Cancel
      </button>
      <button
        mat-button
        class="action-btn"
        (click)="deleteUser()"
        data-test-id="delete-user-submit"
      >
        Delete User
      </button>
    </div>
  </div>
</div>
